// Why a policy governs a case, as an operator reads it. Cases stores the policies resolver's
// explanation verbatim (`policyMatchReason`), and the resolver writes exactly four English
// templates (apps/policies/src/persistence/policy-ranking.ts `buildExplain`). This recognises
// them and words them in the console's language; anything else is NOT shown — never raw
// English or a debug string on screen. Pure: the translator is handed in.

export type PolicyReasonKey = 'onlyMatch' | 'priority' | 'specificity' | 'version';

const TEMPLATES: ReadonlyArray<[PolicyReasonKey, RegExp]> = [
  ['onlyMatch', /^Only matching policy for this scope\.?$/],
  ['priority', /^Won on priority \(-?\d+ > -?\d+\)\.?$/],
  ['specificity', /^Tie on priority -?\d+ → won on more specific scope \(\d+ > \d+\)\.?$/],
  ['version', /^Tie on priority -?\d+ \+ scope → won on version recency \(v\d+\)\.?$/],
];

/** Which of the resolver's four reasons this is, or `null` (unknown, empty). */
export function policyReasonKey(raw: string | null | undefined): PolicyReasonKey | null {
  const text = raw?.trim();
  if (!text) return null;
  return TEMPLATES.find(([, re]) => re.test(text))?.[0] ?? null;
}

/** The reason in words (`roster:policyReason.*`), or `null` — then nothing is shown. */
export function policyReasonText(
  raw: string | null | undefined,
  t: (key: string) => string,
): string | null {
  const key = policyReasonKey(raw);
  return key ? t(`roster:policyReason.${key}`) : null;
}
